import { createAction } from '@reduxjs/toolkit';
import { LocalStorage } from '../../shared/utils';

export const setUpdatePlanBannerState = createAction('billing/setUpdatePlanBannerState');

export const reducer = (builder) => {
  builder.addCase(
    setUpdatePlanBannerState.type,
    (state, { payload }) => {
      LocalStorage.set('isUpdatePlanBannerHidden', payload);

      return { ...state, isUpdatePlanBannerHidden: payload };
    },
  );
};
